module.exports = __webpack_public_path__ + "img/artamonova.08161766.jpg";